import React, { ReactNode } from 'react'

import { ThemeProvider as SCThemeProvider } from 'styled-components'

import DEFAULT_THEME from 'Theme/DefaultTheme'

type Props = {
  children: ReactNode
}

function ThemeProvider({ children }: Props) {
  return <SCThemeProvider theme={DEFAULT_THEME}>{children}</SCThemeProvider>
}

export default ThemeProvider
